import { useState, useEffect } from "react";
import upArrow from "../assets/icons/up-arrow.svg";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          className="fixed bottom-4 right-4 md:bottom-10 md:right-10 z-50 p-2 md:p-3 bg-gray rounded-full shadow-lg hover:bg-opacity-80 transition-all duration-300 flex items-center justify-center"
        >
          <img src={upArrow} alt="up arrow" className="w-6 h-6 md:w-8 md:h-8" />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
